const statuses = {
    initial: "Initial",
    paused: "Paused",
    running: "Running"
}

export {
    statuses
}